import React from 'react';
import { MapTo } from '@adobe/aem-react-editable-components';
import { withConditionalPlaceHolder } from '@adobe/aem-core-components-react-base';
import { Footer, FooterEmptyFn, FooterProps } from './Footer';

const RESOURCE_TYPE = 'learning-academy/components/custom/footer';

const EditConfig = {
  emptyLabel: 'Footer: Please configure the component.',
  isEmpty: FooterEmptyFn,
};

const WithEmptyPlaceholderFooter = (props: FooterProps) => {
  const Wrapped = withConditionalPlaceHolder(Footer, FooterEmptyFn);

  return <Wrapped {...props} />;
};

MapTo<FooterProps>(RESOURCE_TYPE)(WithEmptyPlaceholderFooter, EditConfig);

export default WithEmptyPlaceholderFooter;
